import { memo } from 'react';
import { selectIsExportSetupsLoading } from 'features/setups/selectors';
import { TableToolbar, type TableToolbarProps } from 'ui/widgets/Table';

const GeneralSetupsToolbar = (props: Pick<TableToolbarProps, 'onExport'>) => (
    <TableToolbar
        {...props}
        selectIsExportLoading={selectIsExportSetupsLoading}
    />
);

export default memo(GeneralSetupsToolbar);
